import { NgModule } from '@angular/core';

import { AuthenticationRoutingModule } from './authentication.routing';
import { LoginComponent } from './login/login.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AlertModule } from '@michelin/theme';
import { PasswordComponent } from './password/password.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';

@NgModule({
  declarations: [LoginComponent, PasswordComponent, UpdatePasswordComponent],
  imports: [SharedModule, AlertModule, AuthenticationRoutingModule]
})
export class AuthenticationModule {}
